import { parseEther } from "viem";

/**
 * Configuration for Blessnet safety features
 * These settings control when bridging to Blessnet is allowed
 */

// Get the minimum BLESS balance from environment variables
// Default to 100 BLESS if not specified
const DEFAULT_MINIMUM_BLESS_BALANCE = "100";

const rawMinimumBalance = process.env.NEXT_PUBLIC_MIN_BLESS_BALANCE_FOR_BRIDGING
  || DEFAULT_MINIMUM_BLESS_BALANCE;

export const BLESSNET_SAFETY_CONFIG = {
  /**
   * Minimum BLESS balance required on parent chain (Arbitrum) for the target contract
   * before allowing bridging to Blessnet. This is specified in BLESS tokens (not wei).
   */
  MINIMUM_BLESS_BALANCE_WEI: parseEther(rawMinimumBalance),

  /**
   * Minimum BLESS balance in human readable format for display purposes
   */
  MINIMUM_BLESS_BALANCE_DISPLAY: rawMinimumBalance,
} as const;
